import { ResponseError, type Session } from '@ory/client-fetch';
import { kratos } from '~/lib/ory/kratos';

/**
 * Get the session
 * @returns The session or null if the session is not found
 */
export async function getSession(): Promise<Session | null> {
  try {
    return await kratos.toSession({});
  } catch (err) {
    if (err instanceof ResponseError) {
      if (err.response.status === 401) {
        return null;
      }
    }

    throw err;
  }
}
